import { render, staticRenderFns } from "./Noticias.vue?vue&type=template&id=2916d5bb&scoped=true&"
import script from "./Noticias.vue?vue&type=script&lang=js&"
export * from "./Noticias.vue?vue&type=script&lang=js&"
import style0 from "./Noticias.vue?vue&type=style&index=0&id=2916d5bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916d5bb",
  null
  
)

export default component.exports